import React from 'react'

import Caption from 'components/Luxkit/Typography/Caption'

export const SEARCH_MENU_LIST_CAPTION_CLASS_NAME = 'search-menu-list-caption'

interface Props {
  children: React.ReactNode
}

function SearchMenuListCaption(props: Props) {
  const { children } = props

  return <Caption
    className={SEARCH_MENU_LIST_CAPTION_CLASS_NAME}
    variant="large"
    weight="bold"
    format="uppercase"
  >
    {children}
  </Caption>
}

export default SearchMenuListCaption
